import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { SYSTEM_ENTITIES_ROUTE } from 'apiRoutes';
import { Table } from 'components/tables/Table';
import { systemEntitiesTableColumns } from 'components/systemEntities/SystemEntityTable/systemEntitiesTableColumns';
import { useNavigate } from 'react-router-dom';
import { SystemEntity } from 'domain/systemEntity/interfaces/SystemEntity';

const SubscriptionSystemEntitiesTable: FunctionComponent<{
	subscriptionId: number;
	onUserUnassigned: () => void;
}> = ({ subscriptionId, onUserUnassigned }) => {
	const { data, status } = useGetOnMount(
		`${SYSTEM_ENTITIES_ROUTE}/GetSystemEntitiesBySubscriptionId?SubscriptionId=${subscriptionId}`,
	);

	const [systemEntities, setSystemEntities] = useState<SystemEntity[]>([]);
	useEffect(() => {
		if (!data) return;

		setSystemEntities(data);
	}, [data]);

	const navigate = useNavigate();

	const onUnassigned = (subscriberId: string) => {
		setSystemEntities(systemEntities.filter((a) => a.id != subscriberId));
		onUserUnassigned();
	};

	const columns = useMemo(
		() => [systemEntitiesTableColumns.name()],
		[systemEntities],
	);

	return (
		<Table<SystemEntity>
			columns={columns}
			requestStatus={status}
			data={systemEntities}
			withPagination={systemEntities?.length > 20}
			onRowClicked={(row: SystemEntity) => {
				navigate(`/systementities/${row.id}`);
			}}
		/>
	);
};

export default SubscriptionSystemEntitiesTable;
